import { TeeTimeType } from './types';

const MAX_PLAYERS = 4;
const HIGHLIGHT_THRESHOLD = 6;
const HIGHLIGHT_START_HOUR = 9;
const HIGHLIGHT_END_HOUR = 11.00001;

function isTimeWithinRange(date: Date, startHour: number, endHour: number): boolean {
  const fractionalHour = date.getHours() + date.getMinutes() / 60;

  return fractionalHour >= startHour && fractionalHour < endHour;
}

export const needsTeeTimeHighlight = (teeTimes: TeeTimeType[]): boolean => {
  const fullAvailableTeeTimes = teeTimes.filter(isEligibleForHighlight);

  return fullAvailableTeeTimes.length < HIGHLIGHT_THRESHOLD;
};

export const isEligibleForHighlight = (teeTime: TeeTimeType): boolean =>
  teeTime.availablePlayers === MAX_PLAYERS &&
  isTimeWithinRange(new Date(teeTime.dateTime), HIGHLIGHT_START_HOUR, HIGHLIGHT_END_HOUR);
